import React from 'react';
import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import Grid from "@material-ui/core/Grid";
import ScenarioTypeIcon from "./ScenarioTypeIcon";
import Typography from "@material-ui/core/Typography";

import Scenario from "../../api/Scenario";


@observer
class ScenarioOptionLabel extends React.Component {
  static propTypes = {
    scenarioId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  };

  render() {
    const { scenarioId } = this.props;
    const scenario = Scenario.getForId(scenarioId);
    return (
      <Grid container spacing={1} wrap="nowrap" alignItems="center">
        <Grid item>
          <code>{scenario.cycleStr}</code>
        </Grid>
        <Grid item>
          <ScenarioTypeIcon scenario={scenario} />
        </Grid>
        <Grid item xs>
          <Typography noWrap variant="inherit">
            {scenario.toString()}
          </Typography>
        </Grid>
      </Grid>
    );
  }
}


export default ScenarioOptionLabel;
